import { createStyles } from "@mantine/emotion";

import { palette } from "_styles/theme";

export default createStyles ( ( theme, props ) => ( {
	root: {
		display         : "flex",
		backgroundColor : theme.other.darkMode ? palette.darkModeDarkGrey : palette.secondaryLightGrey,
		borderRadius    : "3.5rem",
		// width                  : props?.hoverState ? "calc(6 * 3.5rem + 10px)" : "35px", // 80px because of emote and donation icon
		width           : "35px",
		"&:hover"       : {
			width: "calc(6 * 3.5rem + 10px)" // 80px because of emote and donation icon
		},
		maxHeight              : "3.5rem",
		marginLeft             : "1rem",
		transition             : "width 0.5s ease-in-out",
		zIndex                 : 5,
		overflow               : "auto hidden",
		msOverFlowStytle       : "none", /* Internet Explorer 10+ */
		scrollBarWidth         : "none", /* Firefox */
		"&::-webkit-scrollbar" : {
			display: "none" /* Safari and Chrome */
		}
	},
	emoteContainer: {
		display    : "flex",
		marginLeft : props?.hoverState ? "-3rem" : "1rem",
		transition : "margin 0.1s ease-in-out"
	},
	emoteRoot: {
		margin   : "0.5rem 0",
		display  : "flex",
		position : "relative",
		width    : "3.5rem"
	},
	emotes: {
		width     : "2.5rem",
		height    : "2.5rem",
		cursor    : "pointer",
		"&:hover" : {
			transform  : "scale(1.2)",
			transition : "all 0.1 ease-in-out"
			// width  : "3rem",
			// height : "3rem"
		},
		outline: "none"
	},
	svgIcons: {
		width  : "2.5rem",
		height : "2.5rem",
		cursor : "pointer",
		margin : "0.5rem"
	},
	test: {
		opacity    : props?.hoverState ? "0" : "1",
		transition : "opacity 0.2s ease-in-out"
	},
	svgIconsDark: {
		width     : "3.5rem",
		height    : "3.5rem",
		display   : "flex",
		alignSelf : "center",
		cursor    : "pointer"
	}
} ) );

